import { render, staticRenderFns } from "./CreateIssueComment.vue?vue&type=template&id=82369f9e&scoped=true&"
import script from "./CreateIssueComment.vue?vue&type=script&lang=js&"
export * from "./CreateIssueComment.vue?vue&type=script&lang=js&"
import style0 from "./CreateIssueComment.vue?vue&type=style&index=0&id=82369f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82369f9e",
  null
  
)

export default component.exports